import base32Encode from "base32-encode"

export function getCrockfordUUID() {
  const number = crypto.getRandomValues(new Uint8Array((32 / 8) * 4))
  const text = base32Encode(number, "Crockford")
  return text
}
